module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yFGE4W/Images/cover.jpg?1706297464850",
      "alt": "This image is the cover for the book Mad Bomber of New York"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mad Bomber of New York\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Gripping and bizarre . . . A compelling account of a dangerously angry man and the investigation that helped to revolutionize modern police work.” —"), _c('i', [_vm._v("Kirkus Reviews")])]), _c('br'), _c('br'), _c('b'), _c('br'), _c('br'), _vm._v("Between 1940 and 1957, thirty-three bombs—strategically placed in Grand Central Terminal, Penn Station, Radio City Music Hall, Macy’s, and other crowded areas of New York—paralyzed the city, sending shockwaves of fear through the public."), _c('br'), _c('br'), _vm._v("George Metesky, the “Mad Bomber,” unleashed a reign of terror that reverberated through America’s social, legal, and political landscape, ultimately spurring the birth of modern criminal profiling when a psychiatrist was called in to assist in the manhunt. A compelling work of historical true crime, "), _c('i', [_vm._v("The Mad Bomber of New York")]), _vm._v(" is the gripping tale of two individuals engaged in a deadly game of hide-and-seek, with the city of New York caught in the crosshairs."), _c('br'), _c('br'), _vm._v("“A full-fledged biography that evokes the chaos and media circus that the terrorist, George P. Metesky, engendered.” —"), _c('i', [_vm._v("The New York Times")]), _c('br'), _c('br'), _vm._v("“Masterfully told . . . a first-rate true-crime story.” —Scott Christianson, author of "), _c('i', [_vm._v("Bodies of Evidence")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael M. Greenburg\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sterling\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0